import { Download } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const Card = () => (
  <div data-testid="card-page" className="pt-28 sm:pt-36 pb-24 min-h-screen">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <Reveal>
        <Eyebrow>Business card</Eyebrow>
        <h1 className="mt-4 font-display font-extrabold tracking-tight text-3xl sm:text-5xl">
          Your <span className="text-gradient">business card</span>
        </h1>
        <p className="mt-4 text-gray-400 text-sm leading-relaxed">
          Print-ready design, standard card size (85 × 55 mm). Tap a green button below to
          download, or long-press a card image to save it. Forward the files to any print shop.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-8 flex flex-col gap-3">
          <a
            href="/assets/green-planet-business-card.pdf"
            download="Green-Planet-Business-Card.pdf"
            data-testid="card-download-pdf"
            className="inline-flex items-center justify-center gap-2 bg-lime text-obsidian font-semibold px-7 py-4 rounded-full hover:bg-lime-bright transition-all duration-300 text-base"
          >
            <Download size={20} /> Download Print PDF (front + back)
          </a>
          <a
            href="/assets/business-card-front.png"
            download="Green-Planet-Card-Front.png"
            data-testid="card-download-front"
            className="inline-flex items-center justify-center gap-2 border border-lime/50 text-lime font-semibold px-7 py-4 rounded-full hover:bg-lime/10 transition-all duration-300 text-base"
          >
            <Download size={20} /> Download Front Image
          </a>
          <a
            href="/assets/business-card-back.png"
            download="Green-Planet-Card-Back.png"
            data-testid="card-download-back"
            className="inline-flex items-center justify-center gap-2 border border-lime/50 text-lime font-semibold px-7 py-4 rounded-full hover:bg-lime/10 transition-all duration-300 text-base"
          >
            <Download size={20} /> Download Back Image
          </a>
        </div>
      </Reveal>

      {[
        { name: "Front", img: "/assets/business-card-front.png", testid: "card-front" },
        { name: "Back", img: "/assets/business-card-back.png", testid: "card-back" },
      ].map((side, i) => (
        <Reveal key={side.name} delay={i * 0.1}>
          <div className="mt-10">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-lime mb-3">{side.name}</p>
            <img
              src={side.img}
              alt={`Green Planet Technologies business card — ${side.name}`}
              data-testid={`${side.testid}-image`}
              className="w-full rounded-2xl border border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
            />
          </div>
        </Reveal>
      ))}

      <Reveal delay={0.2}>
        <p className="mt-8 text-xs text-gray-500">
          This page is private — it is not linked anywhere on the website. Share the address only
          with your printer.
        </p>
      </Reveal>
    </div>
  </div>
);

export default Card;
